import React, { useState, useEffect} from 'react';
import { Grid, Typography, Box, Button, Container, Card, CardContent, CardMedia, CardActionArea, Divider, Tooltip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VerifiedIcon from '@mui/icons-material/Verified';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import CarCrashOutlinedIcon from '@mui/icons-material/CarCrashOutlined';
import backImage from '../assets/img/back.png';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import {calcEst, showEst, optionsRequired} from '../common/sharedFunctions';
import {FONT_FAMILY} from "../common/sharedFunctions";
import { colors, modernColors } from './Theme/WebTheme';

const Section = (props) => {
  const settings = useSelector(state => state.settingsdata.settings);
  const classes = useStyles();
  const { t } = useTranslation();
  const cartypes = useSelector(state => state.cartypes);
  const [data, setData] = useState([]);
  const auth = useSelector(state => state.auth);
  const [loggedIn, setLoggedIn] = useState(false);
  
  useEffect(() => {
    if (cartypes.cars) {
      setData(cartypes.cars.sort((a, b) => a.pos - b.pos));
    } else {
      setData([]);
    }
  }, [cartypes.cars]);

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);

  const navigate = useNavigate();
  const role = props.role;
  const color=props.color;
  
  const sectionItems = [
    {
      id: 1,
      icon:  <EmojiTransportationIcon sx={{ color: modernColors.primary, fontSize: '36px', mb: 1 }} />,
      sentence1: t('pruduct_section_heading_1'),
      sentence: t('product_section_1'),
    },
    {
      id: 2,
      icon:  <AccessTimeIcon sx={{ color: modernColors.primary, fontSize: '36px', mb: 1 }} />,
      sentence1: t('pruduct_section_heading_2'),
      sentence: t('product_section_2'),
    },
    {
      id: 3,
      icon:   <CarCrashOutlinedIcon sx={{ color: modernColors.primary, fontSize: '36px', mb: 1 }} />,
      sentence1: t('pruduct_section_heading_3'),
      sentence: t('product_section_3'),
    },
    {
      id: 4,
      icon:  <VerifiedIcon sx={{ color: modernColors.primary, fontSize: '36px', mb: 1 }} />,
      sentence1: t('pruduct_section_heading_4'),
      sentence: t('product_section_4'),
    },
  ];

  const VehicleCard = ({ item, index }) => (
    <Card 
      elevation={2} 
      sx={{ 
        maxWidth: 340, 
        borderRadius: '16px', 
        mx: 'auto', 
        mb: 4,
        overflow: 'visible',
        transition: 'all 0.3s ease',
        position: 'relative',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 8px 15px rgba(0,0,0,0.08)',
        },
        pt: 2
      }}
    >
      <Box 
        sx={{ 
          position: 'relative', 
          textAlign: 'center',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -2,
            left: '10%',
            width: '80%',
            height: '4px',
            background: `linear-gradient(90deg, ${modernColors.primary}22, ${modernColors.primary}, ${modernColors.primary}22)`,
            borderRadius: '4px',
          }
        }}
      >
        <CardMedia
          component="img"
          height="120"
          image={item.image}
          alt={item.name}
          sx={{ 
            width: 'auto', 
            maxHeight: 120, 
            margin: '0 auto', 
            objectFit: 'contain',
            transform: 'scale(1.1)'
          }}
        />
      </Box>
      
      <CardContent sx={{ pt: 1, pb: 0 }}>
        <Typography 
          gutterBottom 
          variant="h5" 
          component="div" 
          sx={{ 
            fontFamily: FONT_FAMILY, 
            fontWeight: 600, 
            color: modernColors.textPrimary,
            pb: 0,
            textAlign: 'center',
            position: 'relative'
          }}
        >
          {item.name}
        </Typography>
        
        <Box sx={{ backgroundColor: index % 2 === 0 ? modernColors.hover : 'white', p: 2, mt: 2, borderRadius: '12px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY, color: modernColors.textSecondary }}>
              {t('min_fare')}:
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: FONT_FAMILY, fontWeight: 600, color: modernColors.textPrimary }}>
              {item.min_fare}
            </Typography>
          </Box>
          
          <Divider sx={{ my: 1.5, borderColor: modernColors.border }} />
          
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY, color: modernColors.textSecondary }}>
              {t('extra_info')}:
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: FONT_FAMILY, fontWeight: 600, color: modernColors.textPrimary }}>
              {item.extra_info}
            </Typography>
          </Box>
          
          <Button
            variant="contained"
            sx={{ 
              width: '100%', 
              py: 1.2,
              backgroundColor: modernColors.primary,
              color: modernColors.textPrimary,
              fontFamily: FONT_FAMILY,
              borderRadius: '8px',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#FFB300',
                boxShadow: `0 4px 12px ${modernColors.primary}60`,
              },
              textTransform: 'none',
              fontSize: '1rem',
            }}
            onClick={(e) => { 
              e.preventDefault(); 
              if(loggedIn){
                navigate(((role && role === 'driver' )|| (calcEst && !showEst && !optionsRequired && (role === 'admin' || role === 'fleetadmin'))) ? '/bookings' : '/addbookings', 
                { state: { carData: item }} )
              } else {
                navigate('/login')
              }
            }}
          > 
            {role === 'driver' || (calcEst && !showEst && !optionsRequired && (role === 'admin' || role === 'fleetadmin')) ? t('info'): t('book_now')}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <div>
      <Box sx={{ py: 8, px: { xs: 2, sm: 4 } }}>
        <Container maxWidth="lg">
          {data && data.length > 0 ? (
            <>
              <Typography 
                variant="h3" 
                sx={{ 
                  textAlign: 'center', 
                  fontFamily: FONT_FAMILY, 
                  fontWeight: 700, 
                  color: modernColors.textPrimary,
                  mb: 6,
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: -12,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '80px',
                    height: '4px',
                    backgroundColor: modernColors.primary,
                    borderRadius: '4px',
                  }
                }}
              >
                {"Araçlarımız"}  
                            </Typography>
              
              <Grid container spacing={3}>
                {data.map((item, key) => (
                  <Grid item xs={12} sm={6} md={4} key={key}>
                    <VehicleCard item={item} index={key} />
                  </Grid>
                ))}
              </Grid>
            </>
          ) : (
            <Typography 
              variant="h4" 
              sx={{ 
                textAlign: 'center', 
                py: 10, 
                color: modernColors.textPrimary,
                fontFamily: FONT_FAMILY,
                fontWeight: 500
              }}
            >
              {t('service_start_soon')}
            </Typography>
          )}
        </Container>
      </Box>

      <Box 
        sx={{ 
          position: 'relative',
          py: 10,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${backImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.9,
            zIndex: -1,
          }
        }}
      >
        <Container maxWidth="lg">
          <Typography 
            variant="h3" 
            sx={{ 
              textAlign: 'center', 
              color: modernColors.primary, 
              fontFamily: FONT_FAMILY, 
              fontWeight: 700,
              mb: 6,
              textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -12,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '80px',
                height: '4px',
                backgroundColor: modernColors.primary,
                borderRadius: '4px',
              }
            }}
          >
            {t('best_service_provider')}
          </Typography>
          
          <Grid container spacing={4} justifyContent="center">
            {sectionItems.map((item, key) => (
              <Grid item xs={12} sm={6} md={3} key={key}>
                <Card 
                  elevation={2} 
                  sx={{ 
                    height: '100%', 
                    borderRadius: '16px', 
                    backgroundColor: 'rgba(255,255,255,0.9)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 8px 15px rgba(0,0,0,0.1)',
                    },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    p: 3,
                    textAlign: 'center'
                  }}
                >
                  <Tooltip title={item.sentence1}>
                    <Box>{item.icon}</Box>
                  </Tooltip>
                  
                  <Typography 
                    variant="h6" 
                    sx={{ 
                      fontFamily: FONT_FAMILY, 
                      fontWeight: 600, 
                      color: modernColors.textPrimary,
                      my: 2,
                    }}
                  >
                    {item.sentence1}
                  </Typography>
                  
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      fontFamily: FONT_FAMILY, 
                      color: modernColors.textSecondary,
                      lineHeight: 1.6
                    }}
                  >
                    {item.sentence}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </div>
  );
};

export default Section;